// extracted by mini-css-extract-plugin
export default {"block":"il","flex":"jl","radio":"kl","label":"ll","error":"ml","extra":"nl"};